import { section } from '@settings/common';

const fields = section.fields.filter((field) => {
  return field?.name !== 'color';
});

export function Schema() {
  return {
    category: 'Embed',
    label: 'VideoWise',
    key: 'videoWise',
    fields: [
      {
        label: 'Embed Content',
        name: 'embedContent',
        component: 'html',
      },
      {
        label: 'VideoWise Tile Style',
        name: 'style',
        component: 'select',
        options: [
          { label: 'Default', value: 'default' },
          { label: 'Custom', value: 'custom' },
        ],
      },
      { ...section, fields },
    ],
  };
}
